import { render, staticRenderFns } from "./exportRecording.vue?vue&type=template&id=1d53d802&scoped=true&"
import script from "./exportRecording.vue?vue&type=script&lang=js&"
export * from "./exportRecording.vue?vue&type=script&lang=js&"
import style0 from "./exportRecording.vue?vue&type=style&index=0&id=1d53d802&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d53d802",
  null
  
)

export default component.exports